// Mud auto-calc — pure deterministic helpers.
//
// Used by MudProfileForm.jsx (auto-fill gradient & SG from mud weight) and
// directly testable from node.
//
// Imperial:
//   gradient (psi/ft) = density (ppg) × 0.052
//   SG (—)            = density (ppg) ÷ 8.345
// Metric (internal value "SI"):
//   gradient (kPa/m)  = density (kg/m³) × 0.00981   (≈ ρ × g where g=9.81 m/s²)
//   SG (—)            = density (kg/m³) ÷ 1000

export const IMP_PSI_PER_FT_PER_PPG = 0.052;
export const SI_KPA_PER_M_PER_KGM3  = 0.00981;

const _num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
};

export function deriveMudGradient(density, units) {
  const d = _num(density);
  if (d == null) return null;
  return units === "SI" ? d * SI_KPA_PER_M_PER_KGM3 : d * IMP_PSI_PER_FT_PER_PPG;
}

export function deriveMudSg(density, units) {
  const d = _num(density);
  if (d == null) return null;
  return units === "SI" ? d / 1000 : d / 8.345;
}
